import { useCallback, useState } from "react";
import { useModal } from "@/components/general/base-modal/useModal";
import { BankTransferImportantNotesModal } from "./BankTransferImportantNotesModal";

const DO_NOT_SHOW_BANK_TRANSFER_NOTES_KEY =
  "PNX_USER_PREFERENCES_doNotShowBankTransferImportantNotes";

export const useBankTransferImportantNotesModal = () => {
  const [doNotShowAgain, setDoNotShowAgain] = useState(() => {
    const stored = localStorage.getItem(DO_NOT_SHOW_BANK_TRANSFER_NOTES_KEY);
    return stored === "true";
  });

  const { isOpen, openModal, closeModal, modal } = useModal(
    BankTransferImportantNotesModal,
    // X button / backdrop — just closes, no side effects
    undefined
  );

  const open = useCallback(
    (onConfirm?: (doNotShowAgain: boolean) => void) => {
      const handleConfirm = (dontShowAgain: boolean) => {
        setDoNotShowAgain(dontShowAgain);
        localStorage.setItem(
          DO_NOT_SHOW_BANK_TRANSFER_NOTES_KEY,
          String(dontShowAgain)
        );
        onConfirm?.(dontShowAgain);
      };

      if (!doNotShowAgain) {
        openModal({ onSubmit: handleConfirm } as Parameters<
          typeof openModal
        >[0]);
      } else {
        // "Don't show again" already set — skip the modal and confirm immediately
        onConfirm?.(true);
      }
    },
    [doNotShowAgain, openModal]
  );

  const reset = useCallback(() => {
    localStorage.removeItem(DO_NOT_SHOW_BANK_TRANSFER_NOTES_KEY);
    setDoNotShowAgain(false);
  }, []);

  return {
    isOpen,
    openModal: open,
    closeModal,
    modal,
    reset,
    doNotShowAgain,
  };
};
